import { WidgetLazyLoader } from 'components/common/WidgetLazyLoader';
import { configuration } from 'config/constants';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Language, useLanguage } from 'components/Layout/Language/useLanguage';

declare global {
    namespace React {
        namespace JSX {
            interface IntrinsicElements {
                'sgwt-account-center': {
                    id?: string;
                    'available-languages'?: string;
                    'user-dropdown-links'?: any;
                    authentication?: string;
                    environment?: string;
                    language?: string;
                    mode?: 'sg-markets';
                    debug?: string;
                    ref?: (elt: HTMLElement) => void;
                    'show-sign-in-button'?: boolean;
                };
            }
        }
    }

    interface DocumentEventMap {
        [languageChangedEventName]: CustomEvent<ILanguageChangedEvent>;
    }
}

export const languageChangedEventName = 'sgwt-account-center--language-changed';

export interface ILanguageChangedEvent {
    language: string,
}

export const SgwtAccountCenter: React.FC = () => {
    const { i18n } = useTranslation();
    const { i18nLanguage, changeSelectedLanguage } = useLanguage();

    const handleLanguageChange = (event: CustomEvent<ILanguageChangedEvent>) => {
        i18n.changeLanguage(event.detail.language);
        changeSelectedLanguage(event.detail.language as Language);
    };

    useEffect(() => {
        document.addEventListener(languageChangedEventName, handleLanguageChange);

        return () => {
            document.removeEventListener(languageChangedEventName, handleLanguageChange);
        };
    }, []);

    return <WidgetLazyLoader script={`${configuration.widgetCdnBaseUrl}/widgets/sgwt-account-center/v4/sgwt-account-center.js`}>
        <sgwt-account-center
            id="sgwtAccountCenter"
            language={i18nLanguage}
            available-languages="en,fr"
            authentication="sg-connect-v2"
            mode="sg-markets"
            environment={configuration.sgConnectEnvironment?.toUpperCase() === 'PRODUCTION' ? undefined : configuration.sgConnectEnvironment || undefined}
        />
    </WidgetLazyLoader>;
};
